
































import Vue from 'vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'HomePartners',
  components: {
    Block,
  },
  data: () => ({}),
})
